import { Tooltip } from './contentTooltip.model';

export class ContentCheckIn {
  fromAirport: any;
  cinLastname: any;
  checkIn: Map<string, ContentCheckInItem>;
  id: any;
  label: any;
  fromAirportFloat: any;
  floatlabelLastname: any;
  findYourTripBy: any;
  submitUrl: any;
  tooltips: Map<string, Tooltip> = new Map();
  legacyAppUrl: string;
  helpUrl: any;
  helpLabel: any;
  whereToFindUrl: any;
  whereToFindLabel: any;
  checkInRegexPattern: any;
  redirectNewCheckIn: any;
  submitNewUrl: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      } else {
        this.id = '';
      }
      if (contentjson['label']) {
        this.label = contentjson['label'];
      } else {
        this.label = '';
      }
      if (contentjson['cinLastname']) {
        this.cinLastname = contentjson['cinLastname'];
      } else {
        this.cinLastname = '';
      }
      if (contentjson['fromAirport']) {
        this.fromAirport = contentjson['fromAirport'];
      } else {
        this.fromAirport = '';
      }
      if (contentjson['fromAirportFloat']) {
        this.fromAirportFloat = contentjson['fromAirportFloat'];
      } else {
        this.fromAirportFloat = '';
      }
      if (contentjson['floatlabelLastname']) {
        this.floatlabelLastname = contentjson['floatlabelLastname'];
      } else {
        this.floatlabelLastname = '';
      }
      if (contentjson['checkInRegexPattern']) {
        this.checkInRegexPattern = contentjson['checkInRegexPattern'];
      } else {
        this.checkInRegexPattern = '';
      }
      if (contentjson['submitUrl']) {
        this.submitUrl = contentjson['submitUrl'];
      } else {
        this.submitUrl = '';
      }
      if (contentjson['checkIn']) {
        this.checkIn = this.fillContentCheckInItem(contentjson['checkIn']);
      }
      if (contentjson['findYourTripBy']) {
        this.findYourTripBy = contentjson['findYourTripBy'];
      }
      if (contentjson['toolTipDetails']) {
        this.fillTooltipData(contentjson['toolTipDetails']);
      }
      if (
        contentjson['legacyAppUrl'] &&
        contentjson['legacyAppUrl'].trim() !== ''
      ) {
        this.legacyAppUrl = contentjson['legacyAppUrl'];
      }
      if (contentjson['helpUrl']) {
        this.helpUrl = contentjson['helpUrl'];
      }
      if (contentjson['helpLabel']) {
        this.helpLabel = contentjson['helpLabel'];
      }
      if (contentjson['whereToFindUrl']) {
        this.whereToFindUrl = contentjson['whereToFindUrl'];
      }
      if (contentjson['whereToFindLabel']) {
        this.whereToFindLabel = contentjson['whereToFindLabel'];
      }
      if (contentjson['redirectNewCheckIn']) {
        this.redirectNewCheckIn = contentjson['redirectNewCheckIn'];
      }
      if (contentjson['submitNewUrl']) {
        this.submitNewUrl = contentjson['submitNewUrl'];
      }
    }
  }

  private fillTooltipData(tooltipArray?: any) {
    this.tooltips = new Map();
    if (tooltipArray) {
      for (const tooltip of tooltipArray) {
        this.tooltips.set(tooltip['itemId'], new Tooltip(tooltip));
      }
    }
  }

  private fillContentCheckInItem(contentjson?: any) {
    const checkInItem: Map<string, ContentCheckInItem> = new Map();
    if (contentjson) {
      const keys = Object.keys(contentjson);
      const values = keys.map((key) => contentjson[key]);
      for (const value of values) {
        checkInItem.set(
          value['value'],
          new ContentCheckInItem(value['value'], value)
        );
      }
    }

    return checkInItem;
  }
}

export class ContentCheckInItem {
  id: any;
  title: any;
  value: any;
  trackingNumber: any;
  searchFloatLabelCheck: any;
  trackingNumberType: any;

  constructor(item: any, contentjson?: any) {
    this.id = item;
    if (contentjson) {
      if (contentjson['title']) {
        this.title = contentjson['title'];
      }
      if (contentjson['value']) {
        this.value = contentjson['value'];
      }
      if (contentjson['trackingNumber']) {
        this.trackingNumber = contentjson['trackingNumber'];
      }
      if (contentjson['searchFloatLabelCheck']) {
        this.searchFloatLabelCheck = contentjson['searchFloatLabelCheck'];
      }
      if (contentjson['trackingNumberType']) {
        this.trackingNumberType = contentjson['trackingNumberType'];
      }
    }
  }
}
